import React from 'react'
import DefaultRoute from './router'

const App = () => (
  <DefaultRoute />
)

export default App
